import i18n from '@/i18n';

const startCase = (str: string): string =>
  str
    .replace(/_/g, ' ') // underscores to space
    .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.slice(1));

export function fieldLabel(
  key: string,
  namespace: 'fieldLabels' | 'entityLabels' = 'fieldLabels'
): string {
  const translated = i18n.t(`${namespace}.${key}`, { defaultValue: `__missing__` }) as string;
  if (translated && translated !== `${namespace}.${key}` && translated !== '__missing__')
    return translated;

  // prettify fallback
  return startCase(key);
}
